import React, { useState } from 'react'

import { useScrollPosition } from '@n8tb1t/use-scroll-position'
import { useWindowSize } from 'utils/hooks/useWindowSize'

import { GlobalScrollSnapStyles } from './styles'

export function GlobalScrollSnap() {
  const [globalSnap, setGlobalSnap] = useState(true)
  const { height } = useWindowSize()

  useScrollPosition(
    ({ currPos }) => {
      if (globalSnap && currPos.y < height * -1) {
        setGlobalSnap(false)
      } else if (!globalSnap && currPos.y > height * -1) {
        setGlobalSnap(true)
      }
    },
    [globalSnap, height],
    undefined,
    false,
    200,
  )

  if (!globalSnap) {
    return null
  }

  return <GlobalScrollSnapStyles />
}
